<template>
    <div class="row mb-3">
        <div class="col-12">
            <div class="bg-white rounded p-3 shadow">
                <form>


                    <h3>{{$t('message.MySettings')}}</h3>

                    <hr class="my-2">

                    <div class="form-row mb-2">

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="username"
                                           class="mb-0 font-weight-bold">{{$t('message.Username')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <input type="text" class="form-control" name="username" id="username">
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="email" class="mb-0 font-weight-bold">{{$t('message.Email')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <input type="email" class="form-control" name="email" id="email">
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="phone" class="mb-0 font-weight-bold">{{$t('message.Phone')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <input type="tel" class="form-control" name="phone" id="phone">
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="form-row mb-2">


                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="language"
                                           class="mb-0 font-weight-bold">{{$t('message.SystemLanguage')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <select id="language" name="language" class="form-control">
                                        <option value="he">{{$t('message.Hebrew')}}</option>
                                        <option value="en">{{$t('message.Engliish')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <span class="mb-0 font-weight-bold">{{$t('message.Avatar')}}</span>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <!--<input type="file" class="form-control" id="avatar" name="avatar">-->
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="avatar">
                                        <label class="custom-file-label" for="avatar"
                                               :data-browse="$t('message.Browse')">{{$t('message.ChooseFile')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <h3>{{$t('message.ChangePassword')}}</h3>

                    <hr class="my-2">

                    <div class="form-row mb-2">

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="current_password" class="mb-0 font-weight-bold">{{$t('message.CurrentPassword')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn bg-color-4 border border-right-0 border-color-5 d-flex align-items-center"
                                                    type="button"
                                                    @click="showPassword('current_password')">
                                                <span class="icon-search text-p"></span></button>
                                        </div>
                                        <input type="password" class="form-control border-left-0 border-color-5"
                                               name="current_password" id="current_password" ref="current_password">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="new_password" class="mb-0 font-weight-bold">{{$t('message.NewPassword')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn bg-color-4 border border-right-0 border-color-5 d-flex align-items-center"
                                                    type="button"
                                                    @click="showPassword('new_password')">
                                                <span class="icon-search text-p"></span></button>
                                        </div>
                                        <input type="password" class="form-control border-left-0 border-color-5"
                                               name="new_password" id="new_password" ref="new_password">
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="form-group col-12 col-lg-4">
                            <div class="row">
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center">
                                    <label for="repeat_new_password" class="mb-0 font-weight-bold">{{$t('message.RepeatNewPassword')}}</label>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn bg-color-4 border border-right-0 border-color-5 d-flex align-items-center"
                                                    type="button"
                                                    @click="showPassword('repeat_new_password')">
                                                <span class="icon-search text-p"></span></button>
                                        </div>
                                        <!--
                                        Use VeeValidate to control new password validation!
                                        Source:
                                        https://stackoverflow.com/questions/51265450/vue-js-vee-validate-password-confirmation-always-false
                                        -->
                                        <input type="password" class="form-control border-left-0 border-color-5"
                                               name="repeat_new_password" id="repeat_new_password"
                                               ref="repeat_new_password"
                                               v-validate="'required|confirmed:new_password'"
                                               data-vv-as="new_password">
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary">Save</button>
                    </div>
                    <div>
                        <!-- ERRORS -->
                        <div class="alert alert-danger" v-show="errors.any()">
                            <div v-if="errors.has('new_password')">
                                {{ errors.first('new_password') }}
                            </div>
                            <div v-if="errors.has('repeat_new_password')">
                                {{ errors.first('repeat_new_password') }}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'home',
    methods: {
      showPassword (e) {
        this.$refs[e].type = 'text'
      }
    }
  }
</script>
